import { disallowedISOWeekdays } from 'helpers/moment'

/**
 * shouldDisableDate - Whether or not the date should be disabled, for our DatePicker.
 * NOTE: We do not use our `isAllowedDate` function as it would change Monday => Sunday and thus be "allowed".
 * We calculate our own weekday from the given date.
 *
 * @param {Date} date – A Javascript Date instance, not a moment object!
 *
 * @returns {Boolean} Whether or not it should be disabled.
 */
export default function shouldDisableDate (date) {
  // Convert from a `Date.prototype.getDay()` Sunday = 0, Monday = 1, Saturday = 6
  // To: `moment.isoWeekday()` Monday = 1, Saturday = 6, Sunday = 7
  const isoWeekday = (date.getDay() + 6) % 7 + 1
  return disallowedISOWeekdays.includes(isoWeekday)
}



// WEBPACK FOOTER //
// ./src/components/Date/shouldDisableDate.js